import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";

export default function DesktopDataGridSkeleton({ columns = [], rowsCount = 5 }) {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: "8px",
          maxWidth: "100%",
        }}
      >
        <Table sx={{ minWidth: 0, tableLayout: "fixed" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: theme.palette.grey[50] }}>
              {columns.map((col, colIndex) => {
                if (!col) return null;

                const headerName = col.headerName || col.field || "Field";
                return (
                  <TableCell
                    key={`header-${colIndex}`}
                    sx={{
                      fontWeight: 600,
                      borderBottom: `2px solid ${theme.palette.grey[300]}`,
                      padding: "16px 8px",
                      width: col.width || "auto",
                      minWidth: col.minWidth || 100,
                      maxWidth: col.maxWidth || "none",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {headerName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(rowsCount)].map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  backgroundColor: rowIndex % 2 === 0 ? theme.palette.background.paper : theme.palette.grey[50],
                  "&:hover": {
                    backgroundColor: theme.palette.grey.A100,
                  },
                }}
              >
                {columns.map((col, colIndex) => {
                  if (!col) return null;

                  return (
                    <TableCell
                      key={`cell-${rowIndex}-${colIndex}`}
                      sx={{
                        borderBottom: `1px solid ${theme.palette.grey[200]}`,
                        padding: "12px 8px",
                        width: col.width || "auto",
                        minWidth: col.minWidth || 100,
                        maxWidth: col.maxWidth || "none",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Skeleton variant="text" width={col.skeletonWidth || 120} height={20} />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
